import React from "react";
import SkillCard from "./SkillCard";

function Skills({ skills }) {
  return (
    <div className="flex flex-row flex-wrap align-center justify-center max-w-screen mx-auto mt-8 gap-2">
      {skills.map((skill) => {
        return (
          <SkillCard
            skillName={skill.skillName}
            skillIcon={skill.skillIcon}
            skillDescription={skill.skillDescription}
          />
        );
      })}
    </div>
  );
}

export default Skills;
